import axios from 'axios'
const VarietyModule = {
  namespaced: true,
  state: {
    varietyDetails: [],
    varietyImages: [],
    selectedVariety: []
  },
  mutations: {
    SET_VARIETY_DETAILS: (state, payload) => {
      state.varietyDetails = payload
    },
    SET_SELECTED_VARIETY: (state, payload) => {
      state.selectedVariety = payload
    },
    SET_IMAGE: (state, payload) => {
      state.varietyImages = []
      state.varietyImages = payload
    }
  },
  actions: {
    async fetchVarietyDetails({ commit }, payload) {
      try {
        const response = await axios.get(`portal/varietys/details/${payload}`)
        commit('SET_VARIETY_DETAILS', response.data)
      } catch (error) {
        // const notification = {
        // type: 'error',
        // message: 'Variety Details was a problem: ' + error.message
        // }
        // dispatch('Notification/add', notification, { root: true })
        throw new Error(error)
      }
    },
    async fetchImages({ commit }, payload) {
      try {
        const response = await axios.get(`portal/varietys/images/${payload}`)
        commit('SET_IMAGE', response.data)
      } catch (error) {
        // const notification = {
        //   type: 'error',
        //   message: 'Product Details was a problem: ' + error.message
        // }
        // dispatch('Notification/add', notification, { root: true })
        throw new Error(error)
      }
    }
  },
  getters: {
    getVarietyDetails: state => {
      return state.varietyDetails
    },
    getImages: state => {
      return state.varietyImages
    }
    // getByOrderId: state => orderid => {
    //   return state.data.filter(item => item.idx === orderid)
    // },
    // getActive: state => {
    //   return state.data.filter(item => item.status === 'active')
    // }
  }
}

export default VarietyModule
